import AnimalCardIcon from './animal-card-icon';
export default AnimalCardIcon;
